import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgGift = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8.326 2.424a.75.75 0 0 0-.96 1.152L9.93 5.712H4.385A2.135 2.135 0 0 0 2.25 7.846V12c0 .915.576 1.696 1.385 2v5.615a2.134 2.134 0 0 0 2.134 2.135h12.462a2.134 2.134 0 0 0 2.134-2.135V14A2.135 2.135 0 0 0 21.75 12V7.846a2.135 2.135 0 0 0-2.135-2.134h-5.543l2.562-2.136a.75.75 0 1 0-.96-1.152L12 5.485zM3.75 7.846c0-.35.284-.634.635-.634h6.865v5.423H4.379A.635.635 0 0 1 3.75 12zm9 4.789V7.212h6.865c.35 0 .635.284.635.634V12a.635.635 0 0 1-.63.635h-6.87m-7.615 1.5h6.115v6.115H5.77a.635.635 0 0 1-.635-.635zm7.615 0v6.115h5.48a.635.635 0 0 0 .636-.635v-5.48z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgGift;
